import React, { Component } from 'react'

import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';




export class LocationMap extends Component {

    render() {

        return (
            <section className="map-container">
                <div className="googleMap-style">
                    <Map
                        google={this.props.google}
                        zoom={17}

                        initialCenter={{ lat: 42.99089829530327, lng: -81.25094487342274 }}
                    >
                        <Marker position={{ lat: 42.99089829530327, lng: -81.25094487342274 }} />

                    </Map >
                </div>
            </section>

        )

    }

}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyBr5Hrj6HbCMRZp835uFDXiAfHjJZB1xXs'
})(LocationMap);